// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__QjF9u","author":"Table_author__1w7O0","authorImage":"Table_authorImage__1qRrQ","unreadRow":"Table_unreadRow__2RzEC"};